import React, { useEffect, useRef, useState } from "react";

import { motion, animate } from "motion/react";
import EmojiWave, { defaultEmojis } from "./emojiWave";

export const CompatReactionSentAnimation = ({ emojis, me, user, count }) => {
  return (
    <div>
      <div className="compat-reaction">
        <div className="compat-reactions-avatars">
          <motion.div
            className="compat-avatar-container compat-avatar-container-left"
            initial={{ x: "-50%", y: "3%", rotate: 0, scale: 1 }}
            animate={{ x: "5%", y: "0%", rotate: -9, scale: 1 }}
            transition={{
              duration: 0.8,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <img className="compat-avatar compat-avatar-left" src={me.image} />
          </motion.div>

          <motion.div
            className="compat-avatar-container compat-avatar-container-right"
            initial={{ x: "150%", rotate: 0, scale: 1 }}
            animate={{ x: "75%", y: "10%", rotate: 20, scale: 1.0 }}
            transition={{
              duration: 0.8,
              delay: 0.0,
              ease: [0, 0.71, 0.2, 1.01],
            }}
          >
            <img
              className="compat-avatar compat-avatar-right"
              src={user.image}
            />
          </motion.div>
        </div>

        <div className="compat-reaction-title-container">
          <h4 className="compat-reaction-title">You’ve sent {count}</h4>
          <p className="compat-reaction-subtitle">reactions to each other</p>
        </div>
      </div>
      <EmojiWave emojis={emojis} />
    </div>
  );
};
